class ImageTools {
  static getImageThumbnail = (file, maxWidth = 300, maxHeight = 300) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = function (event) {
        const img = new Image();
        img.src = event.target.result;

        img.onload = function () {
          let newWidth, newHeight;

          if (img.width > img.height) {
            newWidth = maxWidth;
            newHeight = (maxWidth * img.height) / img.width;
          } else {
            newHeight = maxHeight;
            newWidth = (maxHeight * img.width) / img.height;
          }

          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = newWidth;
          canvas.height = newHeight;

          ctx.drawImage(img, 0, 0, newWidth, newHeight);

          const resizedImageData = canvas.toDataURL("image/jpeg", 0.7);

          resolve(resizedImageData);
        };
      };

      reader.onerror = function (error) {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  };

  static applyImageEdits = async function applyImageEdits(
    originalFile,
    editData
  ) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();

        img.onload = () => {
          const crop = editData.crop || {
            x: 0,
            y: 0,
            width: img.width,
            height: img.height,
          };

          const rotation = (editData.rotation || 0) % 360;
          const radians = rotation * (Math.PI / 180);
          const rotated = Math.abs(rotation % 180) === 90;

          // Taille finale du canvas après rotation
          const canvasWidth = rotated ? crop.height : crop.width;
          const canvasHeight = rotated ? crop.width : crop.height;

          const canvas = document.createElement("canvas");
          canvas.width = canvasWidth;
          canvas.height = canvasHeight;

          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, canvas.width, canvas.height);

          // Translation au centre + rotation
          ctx.translate(canvasWidth / 2, canvasHeight / 2);
          ctx.rotate(radians);

          // Dessine l'image croppée
          ctx.drawImage(
            img,
            crop.x,
            crop.y,
            crop.width,
            crop.height,
            -crop.width / 2,
            -crop.height / 2,
            crop.width,
            crop.height
          );

          // Ajout des textes, en corrigeant le décalage du crop
          (editData.textOverlays || []).forEach((overlay) => {
            ctx.font = `${overlay.fontSize || 24}px sans-serif`;
            ctx.fillStyle = overlay.color || "black";
            ctx.fillText(
              overlay.text,
              overlay.x - crop.x - crop.width / 2,
              overlay.y - crop.y - crop.height / 2
            );
          });

          canvas.toBlob(
            (blob) => {
              if (blob) resolve(blob);
              else reject(new Error("Canvas toBlob failed"));
            },
            originalFile.type || "image/jpeg",
            0.95
          );
        };

        img.onerror = () => reject(new Error("Failed to load image"));
        img.src = reader.result;
      };

      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsDataURL(originalFile);
    });
  };

  static compressToTargetSize = async (
    file,
    maxWidth = 1920,
    maxHeight = 1080,
    targetSizeMB = 0.8
  ) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);

    return new Promise((resolve, reject) => {
      img.onload = async () => {
        let width = img.width;
        let height = img.height;
        let quality = 0.9;
        let canvas = document.createElement("canvas");
        let blob = null;

        const originalName = file.name;
        const newName = originalName.replace(/\.[^/.]+$/, ".jpg");

        while (true) {
          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          // eslint-disable-next-line no-loop-func
          blob = await new Promise((res) => {
            canvas.toBlob((result) => res(result), "image/jpeg", quality);
          });

          const fileSizeMB = blob.size / (1024 * 1024);

          if (
            fileSizeMB <= targetSizeMB ||
            (width <= maxWidth && height <= maxHeight)
          ) {
            break;
          }

          width *= 0.9;
          height *= 0.9;
        }

        while (blob.size / (1024 * 1024) > targetSizeMB && quality > 0.1) {
          quality -= 0.1;

          // eslint-disable-next-line no-loop-func
          blob = await new Promise((res) => {
            canvas.toBlob((result) => res(result), "image/jpeg", quality);
          });
        }

        const compressedFile = new File([blob], newName, {
          type: "image/jpeg",
        });

        resolve(compressedFile);
      };

      img.onerror = (err) => reject(err);
    });
  };
}
export default ImageTools;
